import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'reactstrap'
import RabbitIcon from "../../images/rabbit.svg"
import SpeedometerIcon from "../../images/speedometer.svg"
import ChartIcon from "../../images/chart.svg"
import PulseIcon from "../../images/pulse.svg"
import './advantages.scss'

const Advantages = () => {
  return (
    <div className="advantages">
      <h2 className="advantages-title">Manage Remote Users, Networks, and Technology with HubbleIQ Plus</h2>
      <Row className="advantages-container">
        <Col xs={12} sm={6} className="col">
          <div className="advantages-col">
            <div className="advantages-col-img">
              <img src={RabbitIcon} alt="rabbit icon"/>
            </div>
            <div className="advantages-col-title">
              <h4>Remote Network <br /> Performance management</h4>
            </div>
            <p className="advantages-col-text">Monitor the internet performance and WiFi quality of your remote users.</p>
          </div>
        </Col>
        <Col xs={12} sm={6} className="col">
          <div className="advantages-col">
            <div className="advantages-col-img">
              <img src={SpeedometerIcon} alt="speedometer icon"/>
            </div>
            <div className="advantages-col-title">
              <h4>Management Dashboard</h4>
            </div>
            <p className="advantages-col-text">Manage the digital experience of your remote workforce to supercharge your helpdesk.</p>
          </div>
        </Col>
        <Col xs={12} sm={6} className="col">
          <div className="advantages-col">
            <div className="advantages-col-img">
              <img src={ChartIcon} alt="chart icon"/>
            </div>
            <div className="advantages-col-title">
              <h4>Application Performance <br /> Monitoring</h4>
            </div>
            <p className="advantages-col-text">Detect widespread, regional and user-specific issues with applications and services.</p>
          </div>
        </Col>
        <Col xs={12} sm={6} className="col">
          <div className="advantages-col">
            <div className="advantages-col-img">
              <img src={PulseIcon} alt="pulse"/>
            </div>
            <div className="advantages-col-title">
              <h4>Device performing <br /> monitoring</h4>
            </div>
            <p className="advantages-col-text">Identify which laptops and computers are performing slowing, remotely!</p>
          </div>
        </Col>
      </Row>
    </div>
  )
}

Advantages.propTypes = {}

export default Advantages